<template ref="foo">
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $t("edit") }} {{ $t("seatlayout") }}
      </div>
      <router-link class="btn-blue" to="/cinema-manager/seat-layout"
        >{{ $t("seatlayout") }} {{ $tc("list", 2) }}</router-link
      >
    </div>

    <div class="white-wrapper">
      <div class="row">
        <div class="col-12">
          <div class="d-flex justify-content-between align-items-center">
            <div class="d-flex">
              <h6 class="mb-0">{{ screenDetails.screen_name }}</h6>
            </div>
          </div>
        </div>

        <div class="col-12">
          <header class="cinema-header">
            <div class="row justify-content-between">
              <div class>
                <div class="d-flex justify-content-end">
                  <div
                    v-for="(seatType, seatTypeIndex) in seatTypes"
                    :key="seatTypeIndex"
                    class="mx-1 mx-xl-3"
                    v-on:click="selectSeatType(seatType)"
                  >
                    <div
                      :class="
                        seatTypeSelected == seatType &&
                        seatTypeSelectionMode == 'seatType'
                          ? 'selected_seat_type_active'
                          : ''
                      "
                      v-if="seatType.imageURL"
                      class="cinema-seat my-0 mx-auto bg-blue"
                    >
                      <img :src="seatType.imageURL" height="28" width="27" />
                    </div>
                    <div
                      v-else
                      :class="
                        seatTypeSelected == seatType &&
                        seatTypeSelectionMode == 'seatType'
                          ? `selected_seat_type_active ${seatType.imageClass}`
                          : `${seatType.imageClass}`
                      "
                      class="cinema-seat my-0 mx-auto bg-blue"
                    ></div>
                    <small>{{ seatType.seatName }}</small>
                  </div>

                  <!-- <div class="divider mx-1 mx-xl-3"></div> -->
                </div>
              </div>
            </div>
          </header>
          <div class="row mt-3 mx-0">
            <div
              v-for="(singleScreenType,
              singleScreenTypeIndex) in screenSeatTypes"
              :key="'singleScreenType' + singleScreenTypeIndex"
              class="mx-1"
            >
              <b-button
                variant="default"
                class="btn-outline-blue"
                :class="
                  screenSeatTypeSelected == singleScreenType &&
                  seatTypeSelectionMode == 'screenSeatType'
                    ? 'selected_screen_type_active'
                    : ''
                "
                v-on:click="selectScreenSeatType(singleScreenType)"
                :style="{
                  borderColor: singleScreenType.sst_seat_color_code,
                  backgroundColor: singleScreenType.sst_seat_color_code,
                  color: 'white',
                }"
                >{{ singleScreenType.sst_seat_type }} -
                {{ singleScreenType.sst_no_of_seats }} seat(s)</b-button
              >
              <!-- <div>{{singleScreenType.sst_seat_type}}</div> -->
            </div>

            <div class="mx-1">
              <button
                v-on:click="showName = !showName"
                :class="showName ? 'btn-blue px-2' : 'btn-outline-blue px-2'"
              >
                Show {{ showName ? "Grid" : "Name" }}
              </button>
            </div>
            <div class="mx-1">
              <button
                v-on:click="onReverseOrder()"
                :class="showName ? 'btn-blue' : 'btn-outline-blue'"
              >
                Reverse Order
              </button>
            </div>
            <div class="mx-1">
              <button
                v-on:click="onReverseRow()"
                :class="showName ? 'btn-blue' : 'btn-outline-blue'"
              >
                Reverse Row
              </button>
            </div>
            <div class="mx-1">
              <div class="d-flex align-items-center">
                <label>{{ $t("show") }} {{ $t("row") }} {{ $t("name") }}</label>
                <b-form-checkbox
                  type="checkbox"
                  class="j-checkbox mb-0 ml-2"
                  v-model="showRowNumber"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 mt-3">
          <div class="selected-option">
            <span class="fs-16 font-weight-bold">Selected Option:</span>&nbsp;
            {{
              seatTypeSelectionMode == "screenSeatType" &&
              screenSeatTypeSelected
                ? screenSeatTypeSelected.sst_seat_type
                : seatTypeSelected
                ? seatTypeSelected.seatName
                : ""
            }}
          </div>
          <div
            class="selected-option"
            v-if="seatTypeSelectionMode == 'seatType'"
          >
            <span class="fs-16 font-weight-bold">Capacity:</span>&nbsp;
            {{ seatTypeSelected ? seatTypeSelected.size : 1 }}
          </div>
        </div>

        <div class="col-12">
          <h5 class="text-center pt-3">All Eyes This Way</h5>
          <div
            class="cinema-seatlayout"
            onmousedown="vmVue.$emit('mouseKeyDown', 'test')"
            onmouseup="vmVue.$emit('mouseKeyUp', 'test')"
          >
            <table class="generateSeatLayout">
              <tr v-for="(row, rowIndex) in seats" :key="rowIndex">
                <td>
                  <div class="cinema-seatName">{{ row.rowName }}</div>
                  <input
                    v-if="showName"
                    type="text"
                    class="changeSeatName"
                    v-model="seats[rowIndex].rowName"
                    @change="changeRowName()"
                  />
                </td>
                <td
                  v-for="(column, columnIndex) in row.singleRow"
                  :key="'singleSeat' + columnIndex + 1"
                  colspan="1"
                >
                  <div
                    v-if="isReversedRow == false"
                    :class="showRowNumber || rowIndex == 0 ? '' : 'd-none'"
                    class="cinema-seatNumber"
                  >
                    {{ columnIndex + 1 }}
                  </div>
                  <div
                    v-else
                    :class="showRowNumber || rowIndex == 0 ? '' : 'd-none'"
                    class="cinema-seatNumber"
                  >
                    {{ row.singleRow.length - columnIndex }}
                  </div>
                  <div
                    v-if="
                      !showName &&
                        seats[rowIndex] &&
                        seats[rowIndex].singleRow[columnIndex]
                    "
                    @mousedown="mouseDownOnSeat(columnIndex, rowIndex)"
                    @mouseover="
                      !checkMouseOver()
                        ? mouseOverSeat(columnIndex, rowIndex)
                        : null
                    "
                    @click="
                      checkMouseOver()
                        ? mouseOverSeat(columnIndex, rowIndex)
                        : null
                    "
                    class="cinema-seat"
                    :class="
                      seats[rowIndex].singleRow[columnIndex].seatType &&
                      seats[rowIndex].singleRow[columnIndex].seatType.imageURL
                        ? ''
                        : seats[rowIndex].singleRow[columnIndex].seatType &&
                          seats[rowIndex].singleRow[columnIndex].seatType
                            .imageClass
                    "
                    :style="{
                      borderColor:
                        seats[rowIndex].singleRow[columnIndex].screenSeatType &&
                        seats[rowIndex].singleRow[columnIndex].screenSeatType
                          .sst_seat_color_code
                          ? seats[rowIndex].singleRow[columnIndex]
                              .screenSeatType.sst_seat_color_code
                          : '#000000',
                      backgroundColor:
                        seats[rowIndex].singleRow[columnIndex].screenSeatType &&
                        seats[rowIndex].singleRow[columnIndex].screenSeatType
                          .sst_seat_color_code
                          ? seats[rowIndex].singleRow[columnIndex]
                              .screenSeatType.sst_seat_color_code
                          : '#000000',
                    }"
                  >
                    <img
                      v-if="
                        seats[rowIndex].singleRow[columnIndex].seatType.imageURL
                      "
                      :src="
                        seats[rowIndex].singleRow[columnIndex].seatType.imageURL
                      "
                      height="28"
                      width="27"
                    />
                  </div>

                  <input
                    v-if="showName"
                    type="text"
                    class="changeSeatName"
                    v-model="seats[rowIndex].singleRow[columnIndex].seatName"
                  />
                </td>

                <td>
                  <div class="cinema-seatName">{{ row.rowName }}</div>
                </td>
              </tr>
            </table>
          </div>
        </div>

        <div class="col-12 py-2 text-center">
          <!-- to="add-seat-layout" -->
          <b-button
            :disabled="btenable"
            variant="default"
            v-on:click="submitSeatLayout()"
            class="btn-blue"
            >{{ $t("update") }}</b-button
          >
          <b-button variant="default" @click="reload()" class="btn-black">{{
            $t("reset")
          }}</b-button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="/cinema-manager/seat-layout"
            >{{ $t("cancel") }}</b-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ScreenService from "@/services/ScreenService";
import MasterService from "@/services/MasterService";
import CinemasService from "@/services/CinemasService";
import { groupBy } from "lodash";
import { decryptString } from "@/helper/collection"


var thing = {
  data() {
    return {
      currentCinemaId:null,
      isScheduesAndSeatsFound: false,
      btenable: false,
      showRowNumber: true,
      screenDetails: {
        screen_name: null,
      },
      showName: false,
      screenId: null,
      screenSeatTypes: [],
      seatTypeSelected: {
        seatName: "Normal Seat",
        size: 1,
        value: 1,
        imageClass: "regular-seat",
      },
      mouseDownStatus: false,
      initialSeatValueSelected: {
        row: 0,
        column: 0,
      },
      screenSeatTypeSelected: {},
      seatTypeSelectionMode: "seatType",
      finalSeatValueSelected: {
        row: 0,
        column: 0,
      },
      seatTypes: [
        {
          seatName: "Regular Seat",
          size: 1,
          value: 1,
          imageClass: "regular-seat",
          imageURL: "",
        },
        {
          seatName: "No Seat",
          size: 1,
          value: 2,
          imageClass: "no-seat",
          imageURL: "",
        },
        {
          seatName: "Wheel Chair",
          size: 1,
          value: 3,
          imageClass: "wheelchair",
          imageURL: "",
        },
        {
          seatName: "VIP Seat",
          size: 1,
          value: 5,
          imageClass: "vip-seat",
          imageURL: "",
        },
        // {
        //   seatName: "Couple Seats",
        //   size: 6,
        //   imageClass: "love-seat",
        // },
        {
          seatName: "Only POS",
          size: 1,
          value: 9,
          imageClass: "pointofsale",
          imageURL: "",
        },
        {
          seatName: "Sofa",
          size: 1,
          value: 10,
          imageClass: "sofa-seat",
          imageURL: "",
        },
        {
          seatName: "Recliner",
          size: 1,
          value: 11,
          imageClass: "recliner",
          imageURL: "",
        },
        // {
        //   seatName: "Blocked Seat",
        //   size: 1,
        //   value: 12,
        //   imageClass: "block-seat",
        // },
        {
          seatName: "Broken Seat",
          size: 1,
          value: 13,
          imageClass: "broken-seat",
          imageURL: "",
        },
      ],
      rows: 10,
      columns: 10,
      seats: [],
      seatsCopy: [],
      finalSeatValueSelected: {
        row: 0,
        column: 0,
      },

      //
      isReversedRow: false,
      isReversedRowName: false,
      isReversed: true,
      activeSeatTypes: [],
      // "vipSeat", "regularSeat", "NoSeat", "WheelChair"],
    };
  },
  beforeMount() {
      const { cinema_id = null } = this.$route.query;
        if (!cinema_id) {
          this.$toasted.show("Cinema is missing")
          this.$router.push("/cinema-manager/screens")
        }
        this.currentCinemaId = decryptString(String(cinema_id))
    // this.onChangeRowsColumns();
    // this.checkSeatsScheduleCount();
  },
  mounted() {
    this.screenId = this.$route.params.screenID;
    // this.checkSeatsScheduleCount().then(() => {
    // this.getSeatTypes();
    // this.getSeatScreenType();

    this.checkSeatsData();
    // vmVue.$on("mouseKeyDown", this.mouseDown);
    // vmVue.$on("mouseKeyUp", this.mouseUp);
    // });
  },
  methods: {
    checkSeatsData: async function() {
      await this.getSeatsScheduleCount();
      if (this.isScheduesAndSeatsFound) {
        this.$router.go(-1);
      } else {
        await this.getSeatTypes();
        this.getSeatScreenType();
      }
    },
    getSeatsScheduleCount: async function() {
      let payload = {
        conditionColName: "screen_id",
        checkNewSeatLayout: true,
        conditionId: this.$route.params.screenID,
        cinema_id:this.currentCinemaId
      };

      const response = await CinemasService.GetActiveScreenByCinema(payload);
      // .then((response) => {
      const { data } = response;
      if (data.status && data.Records.length) {
        if (
          data.Records[0].seatbooked_count > 0 ||
          data.Records[0].schedule_count > 0
        ) {
          this.isScheduesAndSeatsFound = true;
        }
      }
      // })
    },
    checkMouseOver() {
      if (
        this.seatTypeSelected &&
        this.seatTypeSelected.hasOwnProperty("size") &&
        this.seatTypeSelected.size > 1
      ) {
        return true;
      } else {
        return false;
      }
    },
    getSeatTypes: async function(screen) {
      let payload = {
        tableName: "ms_seat_reserve_types",
        srt_is_active: "Y",
      };
      this.seatTypes = [];
      try{
              const response=await MasterService.GetActiveList(payload)
       const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.activeSeatTypes = data.Records;
            this.activeSeatTypes.map((x) => {
              let obj = {
                seatName: x.srt_name,
                size: x.srt_seat_capacity,
                value: x.srt_id,
                imageClass: "regular-seat",
                imageURL: this._GetImagePath(x.srt_dash_image_url),
              };
              if (x.srt_id == 1) {
                this.seatTypeSelected = obj;
              }
              this.seatTypes.push(obj);
            });
          } else {
            console.log("data.message :", data.message);
          }
      }catch(error){
        console.log(error)
      }

        
    },
    reload() {
      // location.reload();
      this.getSeatLayout();
    },
    onReverseOrder: function() {
      console.log(this.seats);
      if (this.isReversedRowName) {
        this.seats.sort(function(a, b) {
          return b.rowName.localeCompare(a.rowName);
        });
      } else {
        this.seats.sort(function(a, b) {
          return a.rowName.localeCompare(b.rowName);
        });
      }
      this.isReversedRowName = !this.isReversedRowName;
    },
    onReverseRow: function() {
      if (!this.isReversedRow) {
        let newSeats = this.seats;
        this.seats = [];

        for (let i = 0; i < newSeats.length; i++) {
          let seatRow = [];
          let z = 0;
          let emptySeatsInRow = 0;
          let availableSeats = 0;
          for (let j = 0; j < newSeats[0].singleRow.length; j++) {
            // console.log("row=", i, "column", j, seatRow);
            //Do math to select between final and initial row && final and initial column
            // console.log("singleSeat :", singleSeat);
            let singleSeat = newSeats[i].singleRow[j];
            if (this.seatTypeSelectionMode == "screenSeatType") {
              if (newSeats[i].singleRow[j].seatType.value == 2) {
                emptySeatsInRow++;
              } else {
                availableSeats++;
              }
            } else {
              if (singleSeat.seatType.value == 2) {
                emptySeatsInRow++;
              } else {
                availableSeats++;
              }
            }
            // console.log("singleSeat :", singleSeat);
            // seatRow.push(singleSeat);
            // console.log(this.seats, seatRow);
          }

          console.log({ emptySeatsInRow, availableSeats });
          z = availableSeats;

          for (let j = 0; j < newSeats[0].singleRow.length; j++) {
            console.log("row=", i, "column", j, seatRow);
            //Do math to select between final and initial row && final and initial column
            console.log("singleSeat :", singleSeat);
            let singleSeat = newSeats[i].singleRow[j];
            if (this.seatTypeSelectionMode == "screenSeatType") {
              if (newSeats[i].singleRow[j].seatType.value == 2) {
                singleSeat.seatName = "";
              } else {
                singleSeat.seatName = newSeats[i].rowName + parseInt(z);
                z--;
              }
            } else {
              if (singleSeat.seatType.value == 2) {
                singleSeat.seatName = "";
              } else {
                singleSeat.seatName = newSeats[i].rowName + parseInt(z);
                z--;
              }
            }
            console.log("singleSeat :", singleSeat);
            seatRow.push(singleSeat);
            // console.log(this.seats, seatRow);
          }
          this.seats.push({
            rowName: newSeats[i].rowName,
            singleRow: seatRow,
          });
        }
      } else {
        let newSeats = this.seats;
        this.seats = [];

        for (let i = 0; i < newSeats.length; i++) {
          let seatRow = [];
          let z = 0;
          for (let j = 0; j < newSeats[0].singleRow.length; j++) {
            console.log("row=", i, "column", j, seatRow);
            //Do math to select between final and initial row && final and initial column
            console.log("singleSeat :", singleSeat);
            let singleSeat = newSeats[i].singleRow[j];
            if (this.seatTypeSelectionMode == "screenSeatType") {
              if (newSeats[i].singleRow[j].seatType.value == 2) {
                singleSeat.seatName = "";
              } else {
                singleSeat.seatName = newSeats[i].rowName + parseInt(z + 1);
                z++;
              }
            } else {
              if (singleSeat.seatType.value == 2) {
                singleSeat.seatName = "";
              } else {
                singleSeat.seatName = newSeats[i].rowName + parseInt(z + 1);
                z++;
              }
            }
            console.log("singleSeat :", singleSeat);
            seatRow.push(singleSeat);
            // console.log(this.seats, seatRow);
          }
          this.seats.push({
            rowName: newSeats[i].rowName,
            singleRow: seatRow,
          });
        }
      }
      this.isReversedRow = !this.isReversedRow;
    },
    changeRowName: function() {
      this.isReversedRow = false;
      this.isReversedRowName = false;
      let newSeats = this.seats;
      this.seats = [];
      // let rowIndex = 0;
      // let callAgain = false;
      for (let i = 0; i < newSeats.length; i++) {
        let seatRow = [];
        let z = 0;
        for (let j = 0; j < newSeats[i].singleRow.length; j++) {
          let singleSeat = newSeats[i].singleRow[j];

          if (singleSeat.seatType.value == 2) {
            singleSeat.seatName = "";
          } else {
            singleSeat.seatName = newSeats[i].rowName + parseInt(z + 1);
            z++;
          }

          seatRow.push(singleSeat);
        }

        // if (this.seatTypeSelected.value == 2 && noseat) {
        //   if (emptyColumn == newSeats[i].singleRow.length) {
        //     if (i == this.finalSeatValueSelected.row) {
        //       newSeats[i].rowName = "";
        //     }
        //   } else {
        //     newSeats[i].rowName = String.fromCharCode(rowIndex + 65);
        //     rowIndex++;
        //     callAgain = true;
        //   }
        // }

        this.seats.push({
          rowName: newSeats[i].rowName,
          singleRow: seatRow,
        });
        this.seatsCopy.push({
          rowName: newSeats[i].rowName,
          singleRow: seatRow,
        });
      }
    },
    getSeatScreenType: function() {
      let payload = {
        screenID: this.screenId,
        cinema_id:this.currentCinemaId
      };
      ScreenService.getSeatScreenType(payload)
        .then((result) => {
          const { data } = result;
          if (data.status && data.Records.length > 0) {
            this.screenSeatTypes = data.Records;
            this.getSeatLayout();
          }
        })
        .catch((err) => {});
    },
    getSeatLayout: function() {
      this.seats = [];
      let payload = {
        screenID: this.screenId,
        cinema_id:this.currentCinemaId
      };
      ScreenService.getSeatLayout(payload)
        .then((result) => {
          // console.log("result :", result);
          const { data } = result;
          if (data.status && data.Records.screen_layouts.length > 0) {
            this.screenDetails =
              data.Records["screenDetails"] &&
              data.Records.screenDetails.length > 0
                ? data.Records.screenDetails[0]
                : this.screenDetails;

            let seatData_1 = groupBy(data.Records.screen_layouts, "sl_row_num");
            console.log(seatData_1, "sdfdsfsdf");

            for (let key in seatData_1) {
              try {
                if (seatData_1.hasOwnProperty(key)) {
                  let num = 0;
                  let letr = "";
                  let check = 0;
                  let seatData_2 = seatData_1[key].map((singleSeat) => {
                    if (
                      singleSeat.sl_seat_name != "" &&
                      singleSeat.sl_seat_name != null &&
                      check == 0
                    ) {
                      num = singleSeat.sl_seat_name.match(/\d+/g)[0];
                      letr =
                        singleSeat.sl_seat_name.match(/[a-zA-Z]+/g) &&
                        singleSeat.sl_seat_name.match(/[a-zA-Z]+/g).length > 0
                          ? singleSeat.sl_seat_name.match(/[a-zA-Z]+/g)[0]
                          : singleSeat.sl_seat_name.includes("-")
                          ? singleSeat.sl_seat_name.split("-")[0] + "-"
                          : "";
                      check++;
                    }
                    singleSeat["seatName"] = singleSeat.sl_seat_name;
                    singleSeat["groupId"] = singleSeat.sl_group_id;
                    this.seatTypes.map((x) => {
                      if (x.value == singleSeat.seat_reserve_type_id) {
                        singleSeat["seatTypeImageClass"] = x.imageClass;
                        singleSeat["imageURL"] = x.imageURL;
                        singleSeat["seatType"] = x;
                      }
                      this.screenSeatTypes.map((y) => {
                        if (y.sst_id == singleSeat.screen_seat_type_id) {
                          singleSeat["screenSeatType"] = y;
                        }
                      });
                    });
                    return singleSeat;
                  });

                  if (parseInt(num) > 1) {
                    this.isReversedRow = true;
                  }

                  if (letr.toLowerCase() == "a") {
                    this.isReversedRowName = false;
                  } else {
                    this.isReversedRowName = true;
                  }

                  this.seats.push({
                    rowName: letr,
                    singleRow: seatData_2,
                  });
                  console.log(this.seats);
                  // this.onChangeRowsColumns();
                }
              } catch (err) {
                console.log("Error:", err);
              }
            }
            // this.seats = data.data;
          } else {
            // SHOW ERROR:
            console.log(
              "data.message || `Please try again` :",
              data.message || `Please try again`
            );
          }
        })
        .catch((err) => {
          console.log("Error:catch", err);
        });
    },
    onChangeRowsColumns: function() {
      this.isReversedRow = false;
      this.isReversedRowName = false;
      console.log("test");
      this.seats = [];
      var seatRow = [];
      this.seatsCopy = [];
      for (let i = 0; i < this.rows; i++) {
        seatRow = {
          singleRow: [],
          rowName: String.fromCharCode(i + 65),
        };
        for (let j = 0; j < this.columns; j++) {
          let screenSeatType = {
            sst_id: 0,
            sst_seat_color_code: "#000000",
          };
          seatRow.singleRow.push({
            screenSeatType: screenSeatType, //this.screenSeatTypes[0],
            seatType: {
              seatName: "regularSeat",
              size: 1,
              value: 1,
              imageClass: "regular-seat",
            },
            seatTypeImageClass: "normal-seat",
            seatName: seatRow.rowName + parseInt(j + 1),
            anyOtherData: "test",
          });
        }
        this.seats.push(seatRow);
        this.seatsCopy.push(seatRow);
        console.log("this.seatdwvwtrfyewiuhe872t872y92uw92w9s,", this.seats);
      }
      // console.log(this.seats, seatRow);

      // for (let i = 0; i++; i < this.rows) {
      //   for (let j = 0; j++; j < this.columns) {
      //     seats[i][j] = {
      //       seatType: "normal",
      //       anyOtherData: "test"
      //     };
      //   }
      // }
    },
    selectSeatType: function(seatType) {
      if (seatType.value == 13) {
        this.$toasted.show(
          "Sorry! You can only add broken seat from Manage Broken Seats"
        );
      } else {
        console.log(seatType);
        this.seatTypeSelected = seatType;
        this.seatTypeSelectionMode = "seatType";
      }
    },
    submitSeatLayout: function() {
      console.log("test");
      let self = this;
      let allSeats = [];
      let that = {
        seats: this.seats,
      };
      let count = 0;
      for (let i = 0; i < this.seats.length; i++) {
        for (let j = 0; j < this.seats[0].singleRow.length; j++) {
          if (this.seats[i].singleRow[j].screenSeatType.sst_id == 0) {
            count++;
          }

          console.log("that.seats[i].singleRow[j]", that.seats[i].singleRow[j]);

          allSeats.push({
            sl_row_num: i + 1,
            sl_seat_name: that.seats[i].singleRow[j].seatName,
            sl_col_num: j + 1,
            screen_seat_type_id:
              that.seats[i].singleRow[j]["screenSeatType"].sst_id, // seats[i][j].seatType.seatTypeID
            sl_seat_status: "0",
            sl_group_id:
              that.seats[i].singleRow[j].sl_group_id ||
              that.seats[i].singleRow[j].groupId ||
              null,
            seat_reserve_type_id: that.seats[i].singleRow[j]["seatType"].value,
            // seatType: this.seatTypeSelected,
            // seatTypeImageClass: this.seatTypeSelected.imageClass,
            // seatName: newSeats[i][j].seatName,
            // anyOtherData: "test"
          });
        }
      }
      setTimeout(() => {
        console.log(count);
        if (count > 0) {
          this.$toasted.show("Please Complete remaining " + count + "seat");
          return;
        }
        this.btenable = true;

        let payload = {
          screen_layout: allSeats,
          // screen_layout: [
          //   {
          //     sl_row_num: 1,
          //     sl_seat_name: "",
          //     sl_col_num: 1,
          //     screen_seat_type_id: 643,
          //     sl_seat_status: "0",
          //     seat_reserve_type_id: 1
          //   },
          //   {
          //     sl_row_num: 1,
          //     sl_seat_name: "",
          //     sl_col_num: 2,
          //     screen_seat_type_id: 643,
          //     sl_seat_status: "0",
          //     seat_reserve_type_id: 1
          //   }
          // ],
          screen_id: self.screenId,
          sl_row_num_tot: self.rows,
          sl_col_num_tot: self.columns,
          cinema_id:this.currentCinemaId
        };
        console.log("JSON.stringyfy() :", JSON.stringify(payload));
        ScreenService.editSeatLayout(payload)
          .then((response) => {
            this.btenable = false;
            const { data } = response;
            console.log(response);
            if (!data.error) {
              this.$router.go(-1);
            } else {
            }
          })
          .catch((error) => {
            this.showMessageSnackbar("Error in getReportListData ", error);
          });
      }, 100);
    },
    selectScreenSeatType: function(seatScreenType) {
      console.log(seatScreenType);
      this.screenSeatTypeSelected = seatScreenType;
      this.seatTypeSelectionMode = "screenSeatType";
    },
    mouseDown: function() {
      console.log("testmouseDown", this.mouseDownStatus);
      this.mouseDownStatus = true;
      console.log("testmouseDown2", this.mouseDownStatus);

      // this.mouseOverSeat(seatColumnSelected, seatRowSelected, true);
    },
    mouseUp: function() {
      this.mouseDownStatus = false;
      var count = 0;
      for (let i = 0; i < this.seats.length; i++) {
        for (let j = 0; j < this.seats[i].singleRow.length; j++) {
          if (
            this.seats[i].singleRow[j].screenSeatType.sst_id ==
            this.screenSeatTypeSelected.sst_id
          ) {
            count++;
          }
          if (count > this.screenSeatTypeSelected.sst_no_of_seats) {
            this.$toasted.show(
              "Maximum seats for " +
                this.screenSeatTypeSelected.sst_seat_type +
                " can be " +
                this.screenSeatTypeSelected.sst_no_of_seats
            );
            // for (let k = j; k < this.seats[i].singleRow.length; k++) {
            //   let screenSeatType = {
            //     sst_id: 0,
            //     sst_seat_color_code: "#000000",
            //   };
            //   this.seats[i].singleRow[k].screenSeatType = screenSeatType; // this.screenSeatTypes[0];
            // }
            break;
          }
        }
      }
    },
    mouseDownOnSeat: function(seatColumnSelected, seatRowSelected) {
      console.log("mouseclick");
      this.initialSeatValueSelected.column = seatColumnSelected;
      this.initialSeatValueSelected.row = seatRowSelected;
      this.mouseOverSeat(seatColumnSelected, seatRowSelected, true);
    },
    mouseOverSeat: function(
      seatColumnSelected,
      seatRowSelected,
      clickStatus,
      onlyWorkonClick = false
    ) {
      if (!clickStatus) {
        this.finalSeatValueSelected.column = seatColumnSelected;
        this.finalSeatValueSelected.row = seatRowSelected;
      }
      if (this.mouseDownStatus || clickStatus == true) {
        let newSeats = this.seats;
        this.seats = [];
        let checkIndexArray = [];
        let groupSeatsIndexes = [];
        for (let i = 0; i < newSeats.length; i++) {
          let seatRow = [];
          let z = 0;
          var count = 0;
          let qty = 1;
          let errorCount = 0;

          if (
            this.seatTypeSelected &&
            this.seatTypeSelected.hasOwnProperty("size")
          ) {
            qty = this.seatTypeSelected.size;
          }

          if (
            i == seatRowSelected &&
            this.seatTypeSelectionMode != "screenSeatType"
          ) {
            for (
              let check = seatColumnSelected;
              check < seatColumnSelected + qty;
              check++
            ) {
              if (
                newSeats[i].singleRow[check] &&
                newSeats[i].singleRow[check].seatType.value == 1
              ) {
                let groupObj = {
                  index: check,
                  row: i,
                  col: check,
                  seatName: newSeats[i].singleRow[check].seatName,
                  groupId: `${seatColumnSelected + 1}_${seatRowSelected + 1}_${
                    newSeats[i].singleRow[seatColumnSelected].seatName
                  }`,
                };
                // checkIndexArray.push(check);
                checkIndexArray.push(groupObj);
              } else {
                errorCount++;
                checkIndexArray = [];
              }
            }

            if (errorCount > 0) {
              errorCount = 0;
              checkIndexArray = [];
              for (
                let check = seatColumnSelected;
                check > seatColumnSelected - qty;
                check--
              ) {
                if (
                  newSeats[i].singleRow[check] &&
                  newSeats[i].singleRow[check].seatType.value == 1
                ) {
                  let groupObj = {
                    index: check,
                    row: i,
                    col: check,
                    seatName: newSeats[i].singleRow[check].seatName,
                    groupId: `${seatColumnSelected + 1}_${seatRowSelected +
                      1}_${newSeats[i].singleRow[seatColumnSelected].seatName}`,
                  };
                  // checkIndexArray.push(check);
                  checkIndexArray.push(groupObj);
                } else {
                  errorCount++;
                  checkIndexArray = [];
                }
              }
            }
            let clickedSeat =
              newSeats[seatRowSelected].singleRow[seatColumnSelected];
            console.log("clickedSeat", clickedSeat);
            console.log(
              "newSeats[seatRowSelected].singleRow",
              newSeats[seatRowSelected].singleRow
            );
            if (
              clickedSeat &&
              (clickedSeat.seatType.value == this.seatTypeSelected.value ||
                this.seatTypeSelected.value == 1)
            ) {
              if (
                (clickedSeat.hasOwnProperty("groupId") &&
                  clickedSeat.groupId) ||
                (clickedSeat.hasOwnProperty("sl_group_id") &&
                  clickedSeat.sl_group_id)
              ) {
                groupSeatsIndexes = newSeats[i].singleRow.reduce(function(
                  a,
                  e,
                  i
                ) {
                  if (
                    (clickedSeat.groupId && e.groupId == clickedSeat.groupId) ||
                    (clickedSeat.sl_group_id &&
                      e.sl_group_id == clickedSeat.sl_group_id)
                  )
                    a.push(i);
                  return a;
                },
                []);
                console.log("groupSeatsIndexes", groupSeatsIndexes);
              } else {
                groupSeatsIndexes.push(seatColumnSelected);
              }

              if (groupSeatsIndexes.length > 0) {
                checkIndexArray = [];
                errorCount = 0;
              }
            }
          }

          if (errorCount > 0) {
            this.$toasted.show("No Space");
            checkIndexArray = [];
          }

          console.log("checkIndexArray", checkIndexArray);

          for (let j = 0; j < newSeats[0].singleRow.length; j++) {
            //Do math to select between final and initial row && final and initial column
            if (seatRowSelected == i && seatColumnSelected == j) {
              if (this.seatTypeSelectionMode == "screenSeatType") {
                // console.log(
                //   "object :",
                //   newSeats[i][j],
                //   this.screenSeatTypeSelected
                // );
                let singleSeat = {
                  seatType: newSeats[i].singleRow[j].seatType, //normal, wheelchair, empty
                  screenSeatType: this.screenSeatTypeSelected,
                  seatTypeImageClass: this.seatTypeSelected.imageClass,
                  seatName: newSeats[i].singleRow[j].seatName,
                  anyOtherData: "test1",
                };
                if (newSeats[i].singleRow[j].seatType.value == 2) {
                  singleSeat.seatName = "";
                }
                //  else {
                //   singleSeat.seatName = newSeats[i].rowName + parseInt(z + 1);
                //   z++;
                // }

                seatRow.push(singleSeat);

                //create
              } else if (
                seatRowSelected == i &&
                groupSeatsIndexes.length > 0 &&
                groupSeatsIndexes.includes(j)
              ) {
                let singleSeat = {
                  seatType: this.seatTypes.find((x) => x.value == 1),
                  screenSeatType: newSeats[i].singleRow[j].screenSeatType,
                  seatTypeImageClass: this.seatTypeSelected.imageClass,
                  seatName: newSeats[i].singleRow[j].seatName,
                  anyOtherData: "test2",
                  groupId: null,
                };

                if (this.seatTypeSelected.value == 2) {
                  singleSeat.seatName = "";
                }

                seatRow.push(singleSeat);
              } else {
                let groupDetails = checkIndexArray.find((c) => c.col == j);
                // console.log("object1 :", newSeats[i][j]);
                let singleSeat = {
                  seatType: this.seatTypeSelected, //normal, wheelchair, empty
                  screenSeatType: newSeats[i].singleRow[j].screenSeatType,
                  seatTypeImageClass: this.seatTypeSelected.imageClass,
                  seatName: newSeats[i].singleRow[j].seatName,
                  anyOtherData: "test2",
                  groupId: groupDetails ? groupDetails.groupId : null,
                };
                if (this.seatTypeSelected.value == 2) {
                  singleSeat.seatName = "";
                }

                // } else {
                //   singleSeat.seatName = newSeats[i].rowName + parseInt(z + 1);
                //   z++;
                // }
                if (errorCount > 0) {
                  let singleSeatTemp = newSeats[i].singleRow[j];
                  if (!singleSeatTemp.hasOwnProperty("groupId")) {
                    singleSeatTemp["groupId"] = null;
                  }
                  seatRow.push(singleSeatTemp);
                } else {
                  seatRow.push(singleSeat);
                }
              }
            } else if (
              seatRowSelected == i &&
              groupSeatsIndexes.length > 0 &&
              groupSeatsIndexes.includes(j)
            ) {
              let singleSeat = {
                seatType: this.seatTypes.find((x) => x.value == 1),
                screenSeatType: newSeats[i].singleRow[j].screenSeatType,
                seatTypeImageClass: this.seatTypeSelected.imageClass,
                seatName: newSeats[i].singleRow[j].seatName,
                anyOtherData: "test2",
                groupId: null,
              };

              if (this.seatTypeSelected.value == 2) {
                singleSeat.seatName = "";
              }

              seatRow.push(singleSeat);
            } else if (
              seatRowSelected == i &&
              checkIndexArray.length > 0 &&
              checkIndexArray.some((z) => z.col == j)
            ) {
              let groupDetails = checkIndexArray.find((c) => c.col == j);
              let singleSeat = {
                seatType: this.seatTypeSelected, //normal, wheelchair, empty
                screenSeatType: newSeats[i].singleRow[j].screenSeatType,
                seatTypeImageClass: this.seatTypeSelected.imageClass,
                seatName: newSeats[i].singleRow[j].seatName,
                anyOtherData: "test2",
                groupId: groupDetails ? groupDetails.groupId : null,
              };

              if (this.seatTypeSelected.value == 2) {
                singleSeat.seatName = "";
              }

              seatRow.push(singleSeat);
            } else {
              let singleSeat = newSeats[i].singleRow[j];
              if (!singleSeat.hasOwnProperty("groupId")) {
                singleSeat["groupId"] = null;
              }
              if (this.seatTypeSelectionMode == "screenSeatType") {
                if (newSeats[i].singleRow[j].seatType.value == 2) {
                  singleSeat.seatName = "";
                }
                //  else {
                //   singleSeat.seatName = newSeats[i].rowName + parseInt(z + 1);
                //   z++;
                // }
              } else {
                if (singleSeat.seatType.value == 2) {
                  singleSeat.seatName = "";
                }

                //  else {
                //   singleSeat.seatName = newSeats[i].rowName + parseInt(z + 1);
                //   z++;
                // }
              }

              seatRow.push(singleSeat);
            }
            // console.log(this.seats, seatRow);
          }

          this.seats.push({
            rowName: newSeats[i].rowName,
            singleRow: seatRow,
          });
        }
        // this.$set(this.items, indexOfItem, newValue)
        // if (this.seatTypeSelected.value == 2) {
        //   this.changeRowName(true);
        // }
      }
    },
  },
};
global.thing = thing;
export default thing;
</script>
<style>
.selected_seat_type_active {
  box-shadow: 0px 2px 5px 1px #e41c1c;
}
.selected_screen_type_active {
  box-shadow: 0px 2px 5px 1px #e41c1c !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/CinemaSeatLayoutComponents/editSeatLayout.vue